<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Subject:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'Subject')"
            [blockData]="block.variables?.Subject ?? ''"
            [placeholder]="subjectPlaceholder"
            [maxLength]="4000"
            variable="Subject"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.Subject)"></div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
